import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { BaseFilterWithOptionsComponent } from '../base-filter-with-options/base-filter-with-options.component';
import { FilterState } from '@ui/shared/domain-filter';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-multi-select-filter',
    templateUrl: './multi-select-filter.component.html',
    styleUrls: ['./multi-select-filter.component.scss', '../filter-element/filter-element.component.scss'],
    imports: [
        CommonModule,
        FormsModule,
        MultiSelectModule,
    ],
})
export class MultiSelectFilterComponent extends BaseFilterWithOptionsComponent {
    @ViewChild('MultiSelect')
    public multiselect?: MultiSelect;

    constructor(activeFilterService: FilterState) {
        super(activeFilterService);

        activeFilterService.closeAllOverlays$
            .pipe(
                takeUntilDestroyed(),
            )
            .subscribe(() => {
                this.multiselect?.hide();
            });
    }
}
